import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { WithAuth } from '@/hoc/WithAuth'

import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { useApp } from '@/hooks/useApp'
import { Product } from 'BrokerTsLib/src/enums'
import { Loading } from '../../../components/Loading'
import { Step4Wrapper } from '../../../containers/steps/vehicle/Step4/Step4Wrapper'
import { useInsuranceParams } from '../../../context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '../../../context/MeetingRecordProvider'
import OffersAddonProvider from '../../../context/OffersAddonProvider'
import { SelectedQuoteProvider } from '../../../context/SelectedQuoteContext'
import { SidebarProvider } from '../../../context/SidebarContext'
import { StepsProvider } from '../../../context/StepsContext'
import { WizzardHeaderProvider } from '../../../context/WizzardHeaderContext'

export const GetWizardProductPrefix = (product: Product) => {
  let navigateTarget: string = ''
  switch (product) {
    case Product.TravelInsurance:
      navigateTarget = '/travel'
      break
    case Product.PropertyInsurance:
    case Product.LiabilityInsurance:
      navigateTarget = '/property'
      break
    case Product.VehicleLeasingInsurance:
      navigateTarget = '/leasing'
      break
    case Product.FleetInsurance:
      navigateTarget = '/fleet'
      break
  }

  return navigateTarget
}


const Step4PageComponent = () => {
  const { product } = useApp()
  const navigate = useNavigate()
  const {
    insuranceParamsId: paramsId,
    isLoadingData,
    insuranceParams,
    isContracted,
    error
  } = useInsuranceParams()

  const [showData, setShowData] = useState(!isLoadingData && insuranceParams)
  useEffect(() => {
    setShowData(!isLoadingData && insuranceParams)
  }, [!!insuranceParams, isLoadingData])

  const navigateTarget = GetWizardProductPrefix(product!)

  useEffect(() => {
    if (isContracted) navigate(`${navigateTarget}/steps/complete/${paramsId}`)
  }, [isContracted, navigateTarget])

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData && <Loading large={true} />}
          {!isLoadingData && error && <LoadingFailedAlert />}
          {showData && (
            <MeetingRecordProvider insuranceParamsId={paramsId!}>
              <OffersAddonProvider>
                <SelectedQuoteProvider>
                  <SelectedOffersAddonProvider>
                    <Step4Wrapper />
                  </SelectedOffersAddonProvider>
                </SelectedQuoteProvider>
              </OffersAddonProvider>
            </MeetingRecordProvider>
          )}
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step4Page = WithAuth(Step4PageComponent)
